import ajax from './http'

const orderServer = {
  // 生成订单
  createOrder(param) {
    return ajax({
      url: '/order/submitOrder',
      type: 'post',
      params: param
    })
  },
  // 根据条件查询订单列表
  getOrderList(param) {
    return ajax({
      url: '/order/orderListBaseOnUser',
      type: 'get',
      params: param
    })
  },
  // 根据id请求订单详情
  getOrderDetails(param) {
    return ajax({
      url: '/order/orderInfo',
      type: 'get',
      params: param
    })
  },
  confirmPay(param) {
    return ajax({
      url: '/order/confirmPay',
      type: 'post',
      params: param
    })
  },
  // 请求支付剩余时间
  getRemindTime(param) {
    return ajax({
      url: '/order/getRemindTime',
      type: 'post',
      params: param
    })
  },
  // 点击删除订单
  removeOrder(param) {
    return ajax({
      url: '/order/cancelOrder',
      type: 'post',
      params: param,
    })
  }
}
export default orderServer